
// for vue2-datepicker
let datepicker = {
    days: ['일', '월', '화', '수', '목', '금', '토'],
    months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
    pickers: ['다음 7일', '다음 30일', '이전 7일', '이전 30일'],
    placeholder: {
      date: '날짜 선택',
      dateRange: '기간 선택'
  },
  // en : {
  //   days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  //   months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  //   pickers: ["Next 7 Day's", "Next 30 Day's", "Before 7 Day's", "Before 30 Day's"],
  //   placeholder: {
  //     date: 'Choice Date',
  //     dateRange: 'Choice Date Range'
  //   }
  // }
  
}

export default datepicker